import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import RefreshToken from "./RefreshToken";
import Loader from "App/utils/Loader";
import ToastMessage from "App/common/ToastMessage";
import Maintaince from "App/common/Maintaince";
import { useAppSelector } from "App/store/hooks";

const AuthLayout = lazy(() => import(/* webpackChunkName: "auth-layout" */ "App/common/AuthLayout"));
const AppLayout = lazy(() => import(/* webpackChunkName: "app-layout" */ "App/common/AppLayout"));

const AppNavigator: React.FC = () => {
  const refreshTokenLoaded = useAppSelector((state) => state.user.refreshTokenLoaded);
  const globalData = useAppSelector((state) => state.auth.globalData);

  const isMaintenanceMode = globalData?.maintainceMode;
  const maintenanceTitle = globalData?.maintainceObj?.title;

  return (
    <>
      <ToastMessage />
      <RefreshToken />
      {isMaintenanceMode && <Maintaince isVisible={true} title={maintenanceTitle} />}
      {refreshTokenLoaded ? (
        <Suspense fallback={<Loader message="Loading..." size={30} />}>
          <BrowserRouter>
            <Routes>
              <Route path="/app/*" Component={AppLayout} />
              <Route path="/*" Component={AuthLayout} />
            </Routes>
          </BrowserRouter>
        </Suspense>
      ) : (
        <Loader message="Loading..." size={30} />
      )}
    </>
  );
};

export default AppNavigator;
